// Always call the deployed backend. In production, requests to
// https://eurekainternationalschool.com/api/* are same-origin and get
// proxied (e.g. by Nginx) through to the backend process internally.
// When developing locally, there is no local backend running, so we
// point straight at the deployed one instead of guessing a local port.
const BACKEND_BASE_URL = "https://eurekainternationalschool.com";

export function apiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${BACKEND_BASE_URL}${normalizedPath}`;
}

export async function initiateFeePayment(payload) {
  const response = await fetch(apiUrl("/api/pay-fees"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    throw new Error(data?.detail || data?.error || "Unable to start payment");
  }

  return data;
}

export async function checkPaymentStatus(payload) {
  const response = await fetch(apiUrl("/api/check-status"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    throw new Error(data?.detail || data?.error || "Unable to check payment status");
  }

  return data;
}